import { useEffect } from 'react';

const STATIC_HERO_ID = 'static-hero-shell';
const BOOT_LOADER_ID = 'fw-boot';
const MIN_VISIBLE_MS = 600; // long enough to read as intentional, short enough not to slow anyone down
const FADE_MS = 450;

/**
 * The rider loader is plain HTML in public/index.html so it shows from the very first paint.
 * Once React has rendered the page, fade it out and remove it.
 */
export default function AppBoot({ children }) {
  useEffect(() => {
    const el = document.getElementById(BOOT_LOADER_ID);
    if (!el) return undefined;
    let removeTimer = 0;
    const wait = Math.max(0, MIN_VISIBLE_MS - performance.now());
    const hideTimer = window.setTimeout(() => {
      el.classList.add('is-done');
      el.setAttribute('aria-busy', 'false');
      removeTimer = window.setTimeout(() => el.remove(), FADE_MS);
    }, wait);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  return children;
}

export function removeStaticHeroShell() {
  document.getElementById(STATIC_HERO_ID)?.remove();
}
